import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import { useSeatingState } from "@shared/modules/seating/contexts/useSeatingState";
import { BestAvailableQueryActions } from "@shared/modules/seating/features/BestAvailable/hooks/useBestAvailableQueryParams";
import { useTranslation } from "@shared/utils/internationalization";
import Text from "@ui-kit/typography/Text/Text.web";
import BestAvailableQuantityInput from "../BestAvailableQuantityInput/BestAvailableQuantityInput.web";
import { BestAvailableHeaderProps } from "./BestAvailableSeatingHeader.props";

export default function BestAvailableSeatingHeader({
  minQuantity,
  maxQuantity,
  onOpenTypeQuantitySelect,
}: BestAvailableHeaderProps) {
  const { t } = useTranslation("seating");
  const {
    bestAvailableSeatingQueryParams,
    updateBestAvailableSeatingQueryParams,
    hasSeatsWithMultipleTypes,
    hasPasswordProtectedSeats,
  } = useSeatingState();

  return (
    <Box p="md">
      <Flex direction="column" gap="md">
        {/* fetching is disabled when quantity is 0 */}
        {bestAvailableSeatingQueryParams.quantity === 0 && (
          <Text fontSize="md" fontWeight="bold">
            {t("Choose your seats from the map or select tickets below")}
          </Text>
        )}
        <Flex justify="space-between" align="center">
          {/* Left side filters */}
          <BestAvailableQuantityInput
            asButton={hasSeatsWithMultipleTypes || hasPasswordProtectedSeats}
            withDropdown
            minimum={minQuantity}
            maximum={maxQuantity}
            value={bestAvailableSeatingQueryParams.quantity ?? minQuantity ?? 1}
            onChange={(quantity) => {
              updateBestAvailableSeatingQueryParams({
                type: BestAvailableQueryActions.QUANTITY,
                payload: { quantity: Number(quantity) },
              });
            }}
            onOpenTypeQuantitySelect={onOpenTypeQuantitySelect}
          />
        </Flex>
      </Flex>
    </Box>
  );
}
